module.exports = __webpack_public_path__ + "static/media/cloud-d-v3@2x.c403c0f2.png";